export default __webpack_public_path__ + "static/media/pay_success_icon.1ffb5eaf.svg";